"use client";

import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Icon,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
// import ClientCommentModal from "../../crm/ScriptsAccordionModals/ClientCommentModal/ClientCommentModal";
import Accordion from "../../AccordionStyles/Accordion";
import AccordionSummary from "../../AccordionStyles/AccordionSummary";
import AccordionDetails from "../../AccordionStyles/AccordionDetails";
import StyledTable from "../../StyledTable/StyledTable";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ScriptsAccordionModal from "../../crm/ScriptsAccordionModals";

const renderCallCenterRowSupervisor = (row, onClick) => {
  return (
    <TableRow key={row.id}>
      <TableCell
        className="text-black border-bottom"
        sx={{
          padding: "12px 20px",
          width: 350,
          maxWidth: 350,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            component="img"
            src={row.image}
            alt={row.name}
            sx={{
              width: 36,
              height: 36,
              objectFit: "cover",
              borderRadius: 1,
              flexShrink: 0,
            }}
          />
          <Typography fontWeight={500} noWrap>
            {row.name}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        className="text-black border-bottom"
        sx={{ padding: "12px 20px" }}
      >
        {row.id}
      </TableCell>

      <TableCell
        className="text-black border-bottom"
        sx={{ padding: "12px 20px" }}
      >
        {row.openCount}
      </TableCell>

      <TableCell
        className="text-black border-bottom"
        sx={{ padding: "12px 20px" }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={onClick}
            startIcon={
              <img style={{ width: 20 }} src="/icons/eye.svg" alt="eye" />
            }
            sx={{
              color: "var(--darkPurpleBodyColor) !important",
              textTransform: "none",
              fontSize: "16px",
            }}
          >
            Див
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
};
const ScriptAccordion = ({
  items = [],
  onClick,
  onSubmitEdit,
  onDeleteScriptText,
}) => {
  const [expanded, setExpanded] = useState(null);
  const [modalData, setModalData] = useState({});
  const modalRef = useRef(null);
  const [modalType, setModalType] = useState(null);

  const handleCloseModal = () => setModalType(null);
  const navigate = useNavigate();

  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const openClientModal = (item) => {
    setModalData(item);
    setModalType("client_comment");
  };

  const openEditModal = (item) => {
    setModalData(item);
    setModalType("edit_script");
  };

  return (
    <Box
      sx={{
        boxShadow: "none",
        borderRadius: "7px",
        mb: "25px",
        mt: "20px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        {items.map((item, index) => {
          const panelId = `panel${index + 1}`;
          const isProductGroup = Array.isArray(item.items);

          return (
            <Accordion
              key={panelId}
              expanded={expanded === panelId}
              onChange={handleChange(panelId)}
              className="toc-accordion  rmui-card"
              sx={{
                border: "none",
                borderRadius: "3px",
                mt: index !== 0 ? "10px" : 0,
                width: "100%",
              }}
            >
              <AccordionSummary
                aria-controls={`${panelId}-content`}
                id={`${panelId}-header`}
                className="rmui-card"
                sx={{
                  padding: "9px 25px",
                  borderRadius: "3px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography
                      variant="h4"
                      fontWeight={600}
                      fontSize="14px"
                      className="text-black"
                    >
                      {item.category}
                    </Typography>
                    {item.comment && (
                      <IconButton onClick={() => openClientModal(item)}>
                        <NotificationsIcon
                          sx={{
                            color: "red !important",
                            "& svg": { color: "red !important" },
                          }}
                        />
                      </IconButton>
                    )}
                  </Box>

                  {/* Optional action icons */}
                  <Box sx={{ display: "flex", gap: 1, ml: "auto", mr: 2 }}>
                    {item.scripts && (
                      <>
                        <EditIcon
                          sx={{
                            fontSize: 18,
                            color: "text.secondary",
                            cursor: "pointer",
                          }}
                          onClick={() => openEditModal(item)}
                        />
                        <DeleteIcon
                          sx={{
                            fontSize: 18,
                            color: "text.secondary",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            onDeleteScriptText(item.id);
                            console.log(item);
                          }}
                        />
                      </>
                    )}
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "none" }}>
                {isProductGroup ? (
                  <StyledTable
                    hideHeaders={false}
                    headers={["Назва товару", "ID", "Відкрито разів", ""]}
                    rows={item.items}
                    renderRow={(row) =>
                      renderCallCenterRowSupervisor(row, () => onClick(row.id))
                    }
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    {item.scripts &&
                      item.scripts.map((text, index) => (
                        <Typography
                          key={index}
                          className={` ${
                            index === item.scripts.length - 1
                              ? ""
                              : "border-bottom"
                          }`}
                          sx={{ pl: 3, py: 2, width: "100%" }}
                        >
                          {text}
                        </Typography>
                      ))}
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>

      {/* Client Comment Modal */}
      <ScriptsAccordionModal
        modalRef={modalRef}
        modalType={modalType}
        modalData={modalData}
        onClose={handleCloseModal}
        open={modalType}
        onSubmitEdit={onSubmitEdit}
        onDeleteScriptText={onDeleteScriptText}
      />
    </Box>
  );
};

export default ScriptAccordion;
